import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import TrackingComponent from '../components/TrackingComponent';
import FormValidationComponent from '../components/FormValidationComponent';
import {IS_NEWSLETTER_POPUP_ENABLED, IS_LOGIN_POPUP_ENABLED} from "../utils/Environment";


export default class NewsletterComponent extends Component {

  get SELECTORS() {
    return {
      form: '.js-newsletter-form',
      modalForm: '.js-newsletter-form',
      cta: '.nl-submission',
      privacy: '.js-wrapper-privacy',
      registerForm:'.js-register-form',
      unsubscribeNewsletterRadio: '#unsubscribe-nl [name=param4]',
      userLoggedIn: '#userLoggedIn',
      nlSubscribed: '#nlSubscribed',
      loginFloatingBtn: '.login-floating-icon-container',
      loginFloatingText: '.login-floating-icon-container .login-floating-text',
      loginModalTrigger: '.login-modal-trigger',
      floatingLoginCloseBtn: '.login-floating-icon-container .login-floating-text .vex-close',
      subscribeNlModalTimer: '#subscribeNlModalTimer',
      loginModalTimer: '#loginModalTimer',
      floatingModalTimer: '#floatingModalTimer',
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }


  constructor() {
    super();
    this.form = $(this.SELECTORS.form);
    this.TrackingComponent = new TrackingComponent();
  }

  initProperties() {
    // console.log("initial properties");
    this.modalkey = $(document.body).data('nlKey') ? $(document.body).data('nlKey') : 'default_modal';
    this.hideNlCookieKey = 'nl_' + this.modalkey + "_hide";
    this.hideLoginCookieKey =  "login_modal_hide";
    this.hideFloatingLoginCookieKey =  "login_floating_hide";
    this.startTime = $(document.body).data('nlStartTime'); //new Date().setTime();
    this.endTime = $(document.body).data('nlEndTime'); //new Date().setTime();
    this.templateName = $(document.body).data('nlTemplate');
    this.link = $(document.body).data('nlLink') ? $(document.body).data('nlLink') : '/modals/newsletter'

    if ($(this.SELECTORS.subscribeNlModalTimer).val())
      this.subscribeNlModalTimer = Number($(this.SELECTORS.subscribeNlModalTimer).val());
    else
      this.subscribeNlModalTimer = 10;

    if ($(this.SELECTORS.loginModalTimer).val())
      this.loginModalTimer = Number($(this.SELECTORS.loginModalTimer).val());
    else
      this.loginModalTimer = 10;

    if ($(this.SELECTORS.floatingModalTimer).val())
      this.floatingModalTimer = Number($(this.SELECTORS.floatingModalTimer).val());
    else
      this.floatingModalTimer = 20;

    this.exitIntent = false;

  }

  initModalNl(callback) {

    if (!document.body.classList.contains('page-hide-newsletter')) {
      return $.ajax({
        url: `${this.link}?xhr=true&exitIntent=${this.exitIntent}`,
        dataType: "html"
      }).then(callback);
    }

  }

  initModalLogin(callback) {

    if (!document.body.classList.contains('page--hide-login')) {
      return $.ajax({
        url: `${this.link}?xhr=true&login=true`,
        dataType: "html"
      }).then(callback);
    }

  }

  bindEvents() {

    let ctx = this;
    let $submit = $('.nl-submission');

    $('body').on('submit.newsletter', ctx.SELECTORS.form, function (e) {
      e.preventDefault();
      let $this = $(this);
      let url = $this.attr('action');
      let registerUrl = $this.data('registerUrl');

      let emailval = $this.find('input[name=email]').val();


      if ($this.parents(".modal").length) {
        $this.attr("action", $this.attr("action") + "?xhr=true");
      }

      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: $submit,
        loadertype: $submit.data('loaderLocal')
      });

      $.ajax({
        type: "POST",
        url: `${url}?exitIntent=${ctx.exitIntent}`,
        data: $this.serialize(),
        success: (html) => {
          ctx.log('Newsletter modal successss...');
          let error = $(html).find('span.error').length > 0;
          $this.closest('.js-modal-form-contents').replaceWith($(html).find('.js-modal-form-contents'));
          $(document.querySelector('.modal-newsletter')).addClass('desktop-center');
          $(document.querySelector('.mobile-submit-container .mobile-btn')).addClass('centered');
          $(document.querySelector('.desktop-btn')).hide();
          let isExistingCustomer = $(html).find('input.isExistingCustomer').length > 0;

          //when an user is already subscribed to the newsletter
          if(error){
            $('.js-wrapper-privacy').on('click', function(){
              if($('#privacyNl_2').prop('checked')){
                $('.nl-submission').removeAttr('disabled');
              }else{
                $('.nl-submission').attr('disabled');
              }
            });
          }

          if (!$this.data('loggedin') && !error && !isExistingCustomer) {
            $.ajax({
              url: `${$this.data('registerUrl')}`,
              data: {
                email: emailval,
                afterNewsletter: true
              },
              success: function (resp) {
                let trackingComponent = new TrackingComponent();
                trackingComponent.trackAction('newsletterSubscribe', $submit[0].dataset);

                setTimeout(() => {
                  // strip unuseful content
                  resp = resp.replace(/(<meta[^>]+?>|<meta>|<\/meta>)/img, "");
                  // trigger modal
                  ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                    unsafeContent: resp,
                    modalClass: 'vex-theme-bottom-right-corner modal-register modal-register-from-newsletter'
                  });

                  setTimeout(() => {
                    grecaptcha.render('recaptcha', {
                      'sitekey': document.body.dataset.sitekey,
                      'callback' : function(token) {
                        document.getElementById("registerForm").submit();
                      }
                    });
                  }, 500);

                  setTimeout(() => {
                    if(! $('input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]').prop('checked')){
                      $('#registerForm').find('button[type="submit"]').attr("disabled", true);
                    }
                  }, 700);

                }, 2000);
              },
              complete: function(){
                if(! $('input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]').prop('checked')){
                  $('#registerForm').find('button[type="submit"]').attr("disabled", true);
                }
              },
              error: (xhr) => {
                console.log(xhr);
              }
            });

          }

          Cookies.set(ctx.hideNlCookieKey, 'true', {
            expires: 365,
            path: '/'
          });


        },
        error: function (html) {
          console.log('nl submit error ');
          console.log($this.serialize())
        }
      });
    });


    $('body').on('change.unsubscribeNewsletter', ctx.SELECTORS.unsubscribeNewsletterRadio, function (e) {
      $(this).closest('form').find('.js-submit-unsubscribe-newsletter').prop('disabled',false);
    })

    this.$on(this.$customEvents.MODAL_EVENTS.afterClose, (e) => {
      if (e.payload.rootEl.classList.contains('modal-newsletter')) {
        Cookies.set(ctx.hideNlCookieKey, 'true', {
          expires: 365,
          path: '/'
        })
      }
      else if (e.payload.rootEl.classList.contains('modal-login')) {
        setTimeout(() => {
          $(ctx.SELECTORS.loginFloatingBtn).addClass("show");
      }, (ctx.floatingModalTimer * 1000));

        Cookies.set(ctx.hideLoginCookieKey, 'true', {
          expires: 365,
          path: '/'
        })
      }
    });

    let userLoggedIn = false;
    if ($(ctx.SELECTORS.userLoggedIn).val() == "true")
      userLoggedIn = true;

    let userNlSubscribed = false;
    if ($(ctx.SELECTORS.nlSubscribed).val() == "true")
      userNlSubscribed = true;


    $('body').on('click', ctx.SELECTORS.loginModalTrigger, function (e) {
      ctx.initModalLogin(html => {
          console.info("[Login] modal:open");
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
            unsafeContent: html,
            canScroll: true
          });
      });
    });


    const cookieHideModalNl = Cookies.get(this.hideNlCookieKey);
    const cookieHideModalLogin = Cookies.get(this.hideLoginCookieKey);
    const cookieHideFloatingLogin = Cookies.get(this.hideFloatingLoginCookieKey);

    const isRegisterPage = $('html').data('controller') === "RegisterController" || $('body').hasClass('t-register');
    const isLoginPage = $('html').data('controller') === "LoginController";
    const isCheckoutPage = $('html').data('controller') === "CheckoutController" ||  $('html').data('controller') === "AmazonPayController";
    const isCartPage = $('html').data('controller') === "CartController" ||  $('html').data('controller') === "CartV2Controller"  ;
    const isConfirmPage = $('html').data('controller') === "ConfirmController";
    const isReturnPage = $('html').data('controller') === "ProductReturnController" || $('body').hasClass('t-return-request-modal');
    const isSplashPage = $('html').data('controller') === "LandingController";
    const isUnsubscribePage = $('body').find('form#updatePrivacyForm').length > 0;
    const isFaqPage = $('html').data('controller') === "FaqController";

    const PRODUCT_OPENED = 'productOpened';
    const DIALOG_SHOWN = 'dialogShown';

    const isPerimetralExclusionPage =
    isRegisterPage ||
    isLoginPage ||
    isCheckoutPage ||
    isCartPage ||
    isConfirmPage ||
    isReturnPage ||
    isSplashPage ||
    isUnsubscribePage;

    const isEditMode = document.body.classList.contains('editmode');

    let showModalLogin = !isPerimetralExclusionPage
                          && IS_LOGIN_POPUP_ENABLED
                          && !userLoggedIn
                          && !userNlSubscribed
                          && !cookieHideModalLogin
                          && !isEditMode;

    let showModalNewsletter = !isPerimetralExclusionPage
                              && IS_NEWSLETTER_POPUP_ENABLED
                              && !showModalLogin
                              && !userNlSubscribed
                              && !cookieHideModalNl
                              && !isEditMode;

    // Se i due popup vengono attivati insieme, Login Popup visualizzato da Guest e NL Popup visualizzato da Loggato senza marketing
    if (IS_LOGIN_POPUP_ENABLED && showModalNewsletter && !userLoggedIn)
    {
      showModalNewsletter = false
    }
    if (showModalNewsletter) {
      if (Cookies.get('cookies-disclaimer-v1')) {
        sessionStorage.setItem(DIALOG_SHOWN, true);
        this.initModalNl(html => {
          setTimeout(() => {
            console.info("[Newsletter] modal:open");
            this.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
              unsafeContent: html,
              canScroll: true
            });
            FormValidationComponent.FORM().initializeAll();
        }, (ctx.subscribeNlModalTimer * 1000));
        });
      } else {
        this.$on(this.$customEvents.COOKIE.accepted, ({event}) => {
          sessionStorage.setItem(DIALOG_SHOWN, true);
          this.initModalNl(html => {
            setTimeout(() => {
              console.info("[Newsletter] modal:open");
              this.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                unsafeContent: html,
                canScroll: true
              });
              FormValidationComponent.FORM().initializeAll();
            }, (ctx.subscribeNlModalTimer * 1000));
          });
        });
      }
    }

    const showExitIntentModal = !isPerimetralExclusionPage
                                && !userLoggedIn
                                && !isEditMode
                                && !showModalLogin
                                && !showModalNewsletter;
    let isUs = (document.body.dataset.website === 'us');
    if (isUs) {
      $(document).ready(function() {
        document.addEventListener('mouseout', function (event) {

          if (!event.relatedTarget && !event.toElement && showExitIntentModal) {
            const productOpened = sessionStorage.getItem(PRODUCT_OPENED);
            const nlPopupShown = sessionStorage.getItem(DIALOG_SHOWN);

            if (productOpened == "true" && nlPopupShown == "false") {
              ctx.exitIntent = true;

              if (Cookies.get('cookies-disclaimer-v1')) {
                sessionStorage.setItem(DIALOG_SHOWN, true);
                ctx.initModalNl(html => {
                  setTimeout(() => {
                    console.info("[Newsletter] modal:open");
                    ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                      unsafeContent: html,
                      canScroll: true
                    });
                    FormValidationComponent.FORM().initializeAll();
                    $(document.querySelector('.modal-newsletter')).addClass('desktop-center');
                    $(document.querySelector('.mobile-submit-container .mobile-btn')).addClass('centered');
                    $(document.querySelector('.desktop-btn')).hide();
                }, 0);
                });
              } else {
                this.$on(ctx.$customEvents.COOKIE.accepted, ({event}) => {
                  sessionStorage.setItem(DIALOG_SHOWN, true);
                  ctx.initModalNl(html => {
                    setTimeout(() => {
                      console.info("[Newsletter] modal:open");
                      ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                        unsafeContent: html,
                        canScroll: true
                      });
                      FormValidationComponent.FORM().initializeAll();
                      $(document.querySelector('.modal-newsletter')).addClass('desktop-center');
                      $(document.querySelector('.mobile-submit-container .mobile-btn')).addClass('centered');
                      $(document.querySelector('.desktop-btn')).hide();
                    }, 0);
                  });
                });
              }
            }
          }
        }.bind(this));
       });
    }

    if (showModalLogin) {
      if (Cookies.get('cookies-disclaimer-v1')) {
        sessionStorage.setItem(DIALOG_SHOWN, true);
        this.initModalLogin(html => {
          setTimeout(() => {
            console.info("[Login] modal:open");
            this.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
              unsafeContent: html,
              canScroll: true
            });
          }, (ctx.loginModalTimer  * 1000));
        });
      } else {
        this.$on(this.$customEvents.COOKIE.accepted, ({event}) => {
          sessionStorage.setItem(DIALOG_SHOWN, true);
          this.initModalLogin(html => {
            setTimeout(() => {
              console.info("[Login] modal:open");
              this.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                unsafeContent: html,
                canScroll: true
              });
            }, (ctx.loginModalTimer  * 1000));
          });
        });
      }
    }

    if (IS_LOGIN_POPUP_ENABLED && cookieHideModalLogin && !isPerimetralExclusionPage && !isFaqPage && !userLoggedIn){
      $(ctx.SELECTORS.loginFloatingBtn).addClass("show");
    }

    if (IS_LOGIN_POPUP_ENABLED && !cookieHideFloatingLogin && !isPerimetralExclusionPage && !isFaqPage && !userLoggedIn){
      $(ctx.SELECTORS.loginFloatingText).addClass("show");
    }

    $('body').on('click', ctx.SELECTORS.floatingLoginCloseBtn, function (e) {
      $(ctx.SELECTORS.loginFloatingText).removeClass("show");
      Cookies.set(ctx.hideFloatingLoginCookieKey, 'true', {
        expires: 365,
        path: '/'
      })
    });
  }

  render() {
    this.initProperties();
    // this.checkPrivacy();
    this.bindEvents();
  }
}
